(function() {
    angular
        .module("devicesModule")
        .controller("DeviceTrackerHistoryAllController", DeviceTrackerHistoryAllController)

    DeviceTrackerHistoryAllController.$inject = [
        "$rootScope",
        "$scope",
        "telemetryService",
        "$uibModal"
    ]

    function DeviceTrackerHistoryAllController(
        $rootScope,
        $scope,
        telemetryService,
        $uibModal
    ){
        "use strict"

        $rootScope.historySortTitle = "All Activity"
        $rootScope.historyType = "all"
        $rootScope.allHistory = []
        $rootScope.exportEndDate = new Date()
        $rootScope.page = 1

        $scope.getData()

        $scope.getDeviceHistory = (startDate, endDate) => {
            $scope.changeStartDate(startDate)
            $scope.changeEndDate(endDate)
            $rootScope.minDate = startDate
            $rootScope.maxDate = endDate
            $scope.minDateOptions.maxDate = endDate
            $scope.maxDateOptions.minDate = startDate

            $scope.getData()
        }

        $scope.getScopeBearingName = (telemetry) => {

            if (telemetry.hasOwnProperty("bearing") && telemetry.bearing.hasOwnProperty("degrees")) {

                if ($scope.tracker.meta.isTrackerRCUArrowBoard && telemetry.display.stowed) {

                    if (telemetry.bearing.degrees != 361) {
                        return "Unknown"
                    } else {
                        return "N/A (Display Stowed)"
                    }
                }

                return $rootScope.getBearingName(telemetry.bearing.degrees)

            }
        }

        $scope.minStatus = {
            opened: false
        }
        $scope.maxStatus = {
            opened: false
        }

        $scope.today = () => {
            $scope.dt = new Date()
        }
        $scope.today()

        $scope.dtMin = $rootScope.minDate
        $scope.dtMax = $rootScope.maxDate || new Date()

        $scope.clear = () => {
            $scope.dt = null
        }

        $scope.openMin = () => {
            $scope.minStatus.opened = true
        }

        $scope.openMax = () => {
            $scope.maxStatus.opened = true
        }

        $scope.minDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            maxDate: $scope.dtMax
        }

        $scope.maxDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            minDate: $scope.dtMin
        }

        $scope.format = "MM/dd/yyyy"

        $scope.getRawReport = (recordType, recordID) => {

            const success = (data) => {

                $uibModal.open({
                    templateUrl: "app/modals/raw-report-modal.view.html",
                    controller:  "RawReportModalController",
                    windowClass: "noticeModal",
                    resolve: {
                        rawReport: () => {
                            return data
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })

            }

            const failure = (error) => {
                console.error(error)
            }

            telemetryService.getRawReport($scope.tracker.id, recordType, recordID, success, failure)

        }
    }
})()
